
import { isAppUsing } from 'bits/flip'
import { Component, namespace, Vue } from 'bits/vue'
import { WALL_ACCESS_RIGHT_COLOR_CLASS } from 'bits/wall_access_settings_helper'
import { WallCollaboratorStatus } from 'enums'
import type { UserWallCollaborator } from 'types'
import AvatarImage from 'vuecomponents/avatar_image.vue'
import { ShareSubpanel } from 'vuexstore/modules/share'

const share = namespace('share')
const wallAccessSettings = namespace('wallAccessSettings')

const MAX_COLLABORATORS = 8

@Component({
  components: {
    AvatarImage,
  },
})
class MembersSection extends Vue {
  isAppUsing = isAppUsing
  WallCollaboratorStatus = WallCollaboratorStatus

  WALL_ACCESS_RIGHT_COLOR_CLASS = WALL_ACCESS_RIGHT_COLOR_CLASS

  @share.Action changeActivePanel
  @wallAccessSettings.Getter collaborators!: UserWallCollaborator[]
  @wallAccessSettings.Getter invitedCollaborators!: UserWallCollaborator[]
  @wallAccessSettings.Getter approvedCollaborators!: UserWallCollaborator[]
  @wallAccessSettings.Getter isCollaboratorInInvitedStatus!: (collaborator: Partial<UserWallCollaborator>) => boolean

  get collaboratorsList(): UserWallCollaborator[] {
    return [...this.approvedCollaborators, ...this.invitedCollaborators]
  }

  get hasCollaborators(): boolean {
    return this.collaboratorsList.length > 0
  }

  get displayedCollaborators(): UserWallCollaborator[] {
    return this.collaboratorsList.slice(0, MAX_COLLABORATORS)
  }

  get hiddenCollaborators(): UserWallCollaborator[] {
    return this.collaboratorsList.slice(MAX_COLLABORATORS)
  }

  // Keep it to three lines
  get maxWidth(): string {
    if (this.collaboratorsList.length > 6) {
      return 'calc((100% - 16px)/3)'
    }
    if (this.collaboratorsList.length > 3) {
      return 'calc((100% - 8px)/2)'
    }
    return ''
  }

  openMembersPanel(e): void {
    this.changeActivePanel(ShareSubpanel.Members)
  }
}

export default MembersSection
